import { Alert, Snackbar } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useState, useEffect } from "react"

export function NetworkStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine)
    const { translateText } = useLocalization()

    useEffect(() => {
        const handleOnline = () => setIsOnline(true)
        const handleOffline = () => setIsOnline(false)

        window.addEventListener("online", handleOnline)
        window.addEventListener("offline", handleOffline)

        return () => {
            window.removeEventListener("online", handleOnline)
            window.removeEventListener("offline", handleOffline)
        }
    }, [])

    if (!isOnline) {
        return (
            <Snackbar open anchorOrigin={{ horizontal: "right", vertical: "top" }}>
                <Alert severity="error" variant="filled" sx={{ width: "100%" }}>
                    {translateText(14016)}
                </Alert>
            </Snackbar>
        )
    }

    return null
}
